import { render, staticRenderFns } from "./GiftCardPdf.vue?vue&type=template&id=6ef72566&scoped=true"
import script from "./GiftCardPdf.vue?vue&type=script&lang=js"
export * from "./GiftCardPdf.vue?vue&type=script&lang=js"
import style0 from "./GiftCardPdf.vue?vue&type=style&index=0&id=6ef72566&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef72566",
  null
  
)

export default component.exports